// Optional AI-written NPC posts (§8): requested from the server (which caches, caps daily cost and
// moderates). UI-only: shown in Chirp, never written into sim state (keeps runs replayable).
import { signal } from "@preact/signals";
import { flag } from "@degen/shared/flags";
import type { Engine } from "@degen/sim/engine";
import { liveTokens } from "@degen/sim/market/market";
import { priceOf } from "@degen/sim/market/token";
import { api } from "./api";
import { online } from "./env";

export const aiPosts = signal<{ account: string; text: string }[]>([]);

export function startAiPosts(e: Engine) {
  const pull = async () => {
    if (!flag("aiPosts") || !online()) return;
    const tickers = liveTokens(e.state.market)
      .filter((t) => t.candles.length > 30)
      .map((t) => ({ ticker: t.ticker, change: priceOf(t) / (t.candles[Math.max(0, t.candles.length - 61)].c || 1) - 1 }))
      .sort((a, b) => Math.abs(b.change) - Math.abs(a.change))
      .slice(0, 6);
    try {
      const r = await api<{ posts: { account: string; text: string }[] }>("POST", "/ai-posts", { tickers, sentiment: e.state.market.sentiment.value }, { auth: false });
      aiPosts.value = r.posts;
    } catch {
      /* templates remain the fallback */
    }
  };
  setTimeout(() => void pull(), 20_000);
  setInterval(() => void pull(), 10 * 60_000);
}
